import { z } from "zod";

/** Image de la galerie « À propos » avec légende optionnelle. */
export const AboutImageSchema = z.object({
  url: z.string(),
  caption: z.string().max(500).optional(),
});

export type AboutImageDto = z.infer<typeof AboutImageSchema>;

/** Entrée API : URL seule (legacy) ou objet avec légende. */
export const AboutImageInputSchema = z.union([z.string(), AboutImageSchema]);

/** Normalise une entrée stockée (string legacy ou objet). */
export const normalizeAboutImage = (item: unknown): AboutImageDto | null => {
  if (typeof item === "string" && item.length > 0) {
    return { url: item };
  }
  if (
    item &&
    typeof item === "object" &&
    "url" in item &&
    typeof (item as AboutImageDto).url === "string" &&
    (item as AboutImageDto).url.length > 0
  ) {
    const raw = item as { url: string; caption?: string | null };
    const caption =
      typeof raw.caption === "string" ? raw.caption.trim() : "";
    return caption ? { url: raw.url, caption } : { url: raw.url };
  }
  return null;
};

export const normalizeAboutImages = (items: unknown): AboutImageDto[] => {
  if (!Array.isArray(items)) return [];
  return items
    .map(normalizeAboutImage)
    .filter((item): item is AboutImageDto => item != null);
};

/** Payload API : omet les légendes vides. */
export const serializeAboutImages = (
  items: AboutImageDto[],
): AboutImageDto[] =>
  items.map(({ url, caption }) => ({
    url,
    ...(caption?.trim() ? { caption: caption.trim() } : {}),
  }));
